<template>
    <!-- 订单管理-积分订单管理-票券订单详情 -->
    <content-view>
        <template slot="header">
            <div class="pt24 pb24">
                <span style="cursor: pointer;" @click="$router.back();"><a-icon class="mr8" type="left" />返回订单列表</span>
            </div>
        </template>
        <div class="ticket-order-detail wrap-container-in">
            <a-spin :spinning="spinning">
                <div class="font-weight font-big">用户信息</div>
                <a-row class="mt24">
                    <a-col :span="6">会员昵称：{{orderDetail.account}}</a-col>
                    <a-col :span="6">会员手机号：{{orderDetail.phone}}</a-col>
                </a-row>
                <a-divider></a-divider>
                <div class="font-weight font-big">交易信息</div>
                <a-row class="mt24">
                    <a-col :span="7">交易订单号：{{orderDetail.transNo}}</a-col>
                    <a-col :span="7">下单时间：{{orderDetail.transTime}}</a-col>
                    <a-col :span="7">支付时间：{{orderDetail.payTime | isEmpty}}</a-col>
                </a-row>
                <a-row class="mt24">
                    <a-col :span="7">交易状态：{{orderDetail.transStateStr}}</a-col>
                    <a-col :span="7">应收积分：{{orderDetail.transPoint | thousandFormat}}</a-col>
                    <a-col :span="7">实收积分：{{orderDetail.payPoint | thousandFormat}}</a-col>
                </a-row>
                <a-divider></a-divider>
                <div class="font-weight font-big mb24">票券信息</div>
                <a-table bordered :dataSource="orderDetail.orderTickets" :columns="columns" :pagination="false" :rowKey="(record, index) => index">
                    <template slot="isEmpty" slot-scope="key, row">{{key | isEmpty}}</template>
                    <template slot="thousandFormat" slot-scope="key, row">{{key | thousandFormat}}</template>
                    <template slot="ticketType" slot-scope="ticketType">{{['','期限卡','次卡', "套餐票"][ticketType] || "--"}}</template>
                    <template slot="residueNum" slot-scope="a, row">{{row.residueNum === -1 ? '不限次' : row.residueNum || 0}}</template>
                    <template slot="expireDay" slot-scope="a, row">{{row.expireDay ? row.expireDay.substr(0,10) : '--'}}</template>
                </a-table>
            </a-spin>
        </div>
    </content-view>
</template>
<script type="text/javascript">
    const columns = [
        {
            title: "用户票券号",
            dataIndex: "businessId",
            scopedSlots: { customRender: "businessId" }
        },
        {
            title: "票券商城展示名称",
            dataIndex: "showName"
        },
        {
            title: "票券名称",
            dataIndex: "goodsName"
        },
        {
            title: "票券类型",
            dataIndex: "type",
            scopedSlots: { customRender: "ticketType" }
        },
        {
            title: "商品积分",
            dataIndex: "beforeDiscountPoint",
            scopedSlots: { customRender: "thousandFormat" }
        },
        {
            title: "票券状态",
            dataIndex: "ticketStateStr",
            scopedSlots: { customRender: "isEmpty" }
        },
        {
            title: "剩余可用次数（不包含预约）",
            dataIndex: "residueNum",
            scopedSlots: { customRender: "residueNum" }
        },
        {
            title: "使用有效期",
            dataIndex: "expireDay",
            scopedSlots: { customRender: "expireDay" }
        },
        // {
        //     title: "操作",
        //     key: "action",
        //     scopedSlots: { customRender: "action" }
        // }
    ]
    export default {
        name: "pointOrderDetailTicket",
        components: {
        },
        data() {
            return {
                columns,
                dataSource: [],
                orderDetail: {
                    orderTickets: []
                },
                spinning: true
            };
        },
        computed: {
        },
        methods: {
            // 获取购票订单列表
            getTicketOrderDetail() {
                if (!this.$route.params.transNo || this.$route.params.transNo == 0) return;
                this.$api.order.getOrderDetail({
                    body: {
                        transNo: this.$route.params.transNo,
                        source: 'TICKET',
                        transStateStr: this.$route.query.transStateStr
                    }
                }).then(res => {
                    this.spinning = false;
                    this.orderDetail = res;
                });
            },
            /**
             * @forbidden 禁用/解禁
             */
            forbidden(userTicketId, forbidden) {
                this.$refs.forbiddenModal.show(userTicketId, forbidden);
            },
        },
        created() {},
        mounted() {
            this.getTicketOrderDetail();
        },
        watch: {
        }
    };
</script>
<style lang="scss">
.title-ticket {
    margin-bottom: 8px;
    font-size: 16px;
    color: #000;
    font-weight: 700;
}
.tr-active {
    background-color: #fff6ee;
}
.point-ticket-order-detial {
    padding: 0 16px;
    &-title {
        font-weight: 500;
        font-size: 16px;
    }
}
</style>
